export default __webpack_public_path__ + "static/media/eco-score-D.d229ee0e.svg";